import React from 'react';

const StepIndicator = ({ currentStep }) => {
    const steps = [
        { number: 1, title: 'Basic Info' },
        { number: 2, title: 'Overview' },
        { number: 3, title: 'Specs' },
        { number: 4, title: 'Features' }
    ];

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '40px',
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto 40px auto'
        }}>
            {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        zIndex: 1
                    }}>
                        <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            background: currentStep >= step.number ? 'var(--accent)' : '#e2e8f0',
                            color: currentStep >= step.number ? 'white' : 'var(--text-muted)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: '700',
                            fontSize: '14px',
                            transition: 'all 0.3s',
                            boxShadow: currentStep === step.number ? '0 0 0 4px rgba(59, 130, 246, 0.2)' : 'none'
                        }}>
                            {currentStep > step.number ? '✓' : step.number}
                        </div>
                        <span style={{
                            marginTop: '8px',
                            fontSize: '12px',
                            fontWeight: currentStep === step.number ? '700' : '500',
                            color: currentStep >= step.number ? 'var(--primary)' : 'var(--text-muted)',
                            whiteSpace: 'nowrap'
                        }}>
                            {step.title}
                        </span>
                    </div>

                    {index < steps.length - 1 && (
                        <div style={{
                            flex: 1,
                            height: '2px',
                            background: currentStep > step.number ? 'var(--accent)' : '#e2e8f0',
                            margin: '0 12px',
                            marginBottom: '20px',
                            transition: 'all 0.3s'
                        }} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default StepIndicator;
